import { _ as _defineProperty, a as _slicedToArray } from '../_chunks/dep-50ece1d9.js';
import { u as useApiProps, _ as _toConsumableArray } from '../_chunks/dep-f0ef67c3.js';
import { _ as _objectWithoutProperties } from '../_chunks/dep-06688d2c.js';
import React, { forwardRef, useState, useEffect, useCallback } from 'react';
import '../util/use-size-props.js';
import '../util/use-common-classname.js';
import '../util/use-config.js';

var _excluded = ["colors", "className", "id", "hover", "size", "disabled", "style", "color", "onMouseEnter", "onMouseLeave"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var EmailErrorIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$colors = props.colors,
    colors = _props$colors === void 0 ? [] : _props$colors,
    className = props.className,
    _props$id = props.id,
    id = _props$id === void 0 ? "" : _props$id,
    _props$hover = props.hover,
    hover = _props$hover === void 0 ? "" : _props$hover,
    size = props.size,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    style = props.style,
    color = props.color,
    onMouseEnter = props.onMouseEnter,
    onMouseLeave = props.onMouseLeave,
    resultProps = _objectWithoutProperties(props, _excluded);
  var _useApiProps = useApiProps({
      className: className,
      initColor: ["black", "#D54941", "white"],
      initName: "email-error",
      colors: colors,
      id: id,
      hover: hover,
      size: size,
      style: style,
      disabled: disabled,
      color: color
    }),
    sizeStyle = _useApiProps.sizeStyle,
    cls = _useApiProps.cls;
  var _useState = useState(["black", "#D54941", "white"]),
    _useState2 = _slicedToArray(_useState, 2),
    colorList = _useState2[0],
    setColorList = _useState2[1];
  var _useState3 = useState(["black", "#D54941", "white"]),
    _useState4 = _slicedToArray(_useState3, 2),
    colorsProps = _useState4[0],
    setColorsProps = _useState4[1];
  var _useState5 = useState(["black", "#D54941", "white"]),
    _useState6 = _slicedToArray(_useState5, 2),
    defaultColor = _useState6[0],
    _ = _useState6[1];
  useEffect(function () {
    if (typeof colors === "string" && "email-error".indexOf("-colored") === -1) {
      var col = JSON.parse(JSON.stringify(["black", "#D54941", "white"]));
      var find = col.find(function (item) {
        return item === "currentColor";
      });
      var _col = col;
      if (find) {
        _col = col.map(function (item) {
          if (item === "currentColor") {
            item = colors;
          }
          return item;
        });
      } else {
        _col[0] = colors;
      }
      setColorList(_col);
      setColorsProps(_col);
    }
    if (colors instanceof Array && "email-error".indexOf("-colored") === -1) {
      var colorList1 = JSON.parse(JSON.stringify(["black", "#D54941", "white"]));
      colors.forEach(function (col) {
        var findColorIndex = colorList1.findIndex(function (v) {
          return v === col.targetColor;
        });
        if (findColorIndex >= 0) {
          colorList1[findColorIndex] = col.reviseColor;
        }
      });
      setColorList(_toConsumableArray(colorList1));
      setColorsProps(_toConsumableArray(colorList1));
    }
    if (color && typeof color === "string" && "email-error".indexOf("-colored") === -1) {
      var _col2 = JSON.parse(JSON.stringify(["black", "#D54941", "white"]));
      var _find = _col2.find(function (item) {
        return item === "currentColor";
      });
      var _col3 = _col2;
      if (_find) {
        _col3 = _col2.map(function (item) {
          if (item === "currentColor") {
            item = color;
          }
          return item;
        });
      } else {
        _col3[0] = color;
      }
      setColorList(_col3);
      setColorsProps(_col3);
    }
  }, [JSON.stringify(colors), color, defaultColor]);
  var handleMouseEnter = useCallback(function (event) {
    onMouseEnter && onMouseEnter(event);
    if (!hover || hover.length === 0) return;
    if (colors instanceof Array && "email-error".indexOf("-colored") === -1) {
      if (hover instanceof Array && "email-error".indexOf("-colored") === -1) {
        var colorList1 = JSON.parse(JSON.stringify(colorList));
        hover.forEach(function (col) {
          var findColorIndex = colorList1.findIndex(function (v) {
            return v === col.targetColor;
          });
          if (findColorIndex >= 0) {
            colorList1[findColorIndex] = col.reviseColor;
          }
        });
        setColorList(_toConsumableArray(colorList1));
      }
    }
    if (typeof colors === "string" && "email-error".indexOf("-colored") === -1) {
      if (typeof hover === "string") {
        var col = JSON.parse(JSON.stringify(colorList));
        var find = col.find(function (item) {
          return item === colors;
        });
        var _col = col;
        if (find) {
          _col = col.map(function (item) {
            if (item === colors) {
              item = hover;
            }
            return item;
          });
        } else {
          _col[0] = hover;
        }
        setColorList(_col);
      }
    }
    if (color && typeof color === "string" && "email-error".indexOf("-colored") === -1) {
      if (typeof hover === "string") {
        var _col4 = JSON.parse(JSON.stringify(colorList));
        var _find2 = _col4.find(function (item) {
          return item === color;
        });
        var _col5 = _col4;
        if (_find2) {
          _col5 = _col4.map(function (item) {
            if (item === color) {
              item = hover;
            }
            return item;
          });
        } else {
          _col5[0] = hover;
        }
        setColorList(_col5);
      }
    }
    if (!color && colors.length === 0 && typeof hover === "string" && "email-error".indexOf("-colored") === -1) {
      var _col6 = JSON.parse(JSON.stringify(colorList));
      var _find3 = _col6.find(function (item) {
        return item === "currentColor";
      });
      var _col7 = _col6;
      if (_find3) {
        _col7 = _col6.map(function (item) {
          if (item === "currentColor") {
            item = hover;
          }
          return item;
        });
      } else {
        _col7[0] = hover;
      }
      setColorList(_col7);
    }
    if (!color && colors.length === 0 && hover instanceof Array && "email-error".indexOf("-colored") === -1) {
      var _colorList = JSON.parse(JSON.stringify(colorList));
      hover.forEach(function (col) {
        var findColorIndex = _colorList.findIndex(function (v) {
          return v === col.targetColor;
        });
        if (findColorIndex >= 0) {
          _colorList[findColorIndex] = col.reviseColor;
        }
      });
      setColorList(_toConsumableArray(_colorList));
    }
  }, [colorList, defaultColor, colors, color, hover]);
  var handleMouseLeave = useCallback(function (event) {
    onMouseLeave && onMouseLeave(event);
    if (!hover || hover.length === 0) return;
    var _defaultColor = JSON.parse(JSON.stringify(defaultColor));
    if (colorsProps) {
      _defaultColor = JSON.parse(JSON.stringify(colorsProps));
    }
    setColorList(_defaultColor);
  }, [colorsProps, defaultColor, hover]);
  return /* @__PURE__ */React.createElement("svg", _objectSpread(_objectSpread({
    id: "email-error",
    style: sizeStyle,
    className: cls,
    ref: ref,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, resultProps), {}, {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16"
  }), /* @__PURE__ */React.createElement("g", {
    fill: "none"
  }, /* @__PURE__ */React.createElement("path", {
    d: "M1.33366 2.66669H0.666992V3.33335V4.11113V12.6667V13.3334H1.33366H9.20212C8.96789 12.9284 8.80259 12.4786 8.7223 12H2.00033V4.75389L7.27829 8.54164L7.66699 8.8206L8.05569 8.54164L13.3337 4.75389V7.38866C13.8123 7.46896 14.2621 7.63425 14.667 7.86848V4.11113V3.33335V2.66669H14.0003H1.33366ZM7.66699 7.17944L3.23669 4.00002H12.0973L7.66699 7.17944Z",
    fill: colorList[0],
    fillRule: "evenodd",
    clipRule: "evenodd",
    fillOpacity: "0.9"
  }), /* @__PURE__ */React.createElement("path", {
    d: "M9.6665 11.3333C9.6665 9.67646 11.0096 8.33331 12.6665 8.33331C14.3234 8.33331 15.6665 9.67646 15.6665 11.3333C15.6665 12.9902 14.3234 14.3333 12.6665 14.3333C11.0096 14.3333 9.6665 12.9902 9.6665 11.3333Z",
    fill: colorList[1],
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), /* @__PURE__ */React.createElement("path", {
    d: "M13.1102 11.8309L13.1102 9.38867L12.2235 9.38867L12.2235 11.8309L13.1102 11.8309Z",
    fill: colorList[2]
  }), /* @__PURE__ */React.createElement("path", {
    d: "M13.1133 12.3886H12.2231V13.2788H13.1133V12.3886Z",
    fill: colorList[2]
  })));
});
EmailErrorIcon.displayName = "EmailErrorIcon";

export { EmailErrorIcon as default };
//# sourceMappingURL=email-error.js.map
